import { useFormContext } from 'react-hook-form'
import SelectTagInputWithCheckboxes from '@/components/SelectTagInputWithCheckboxes'
import type { EditPostFormData } from '../types'
import { TYPE_OPTIONS } from '../constants'

const typeItems = TYPE_OPTIONS.map((o) => ({ id: o.value, name: o.label }))

export function FormTypeField() {
  const { watch, setValue } = useFormContext<EditPostFormData>()
  const typeValue = watch('type')
  const value = typeValue ? [typeValue] : []
  return (
    <div>
      <hr className="border-gray-200" />
      <div className="space-y-2 py-3">
        <label className="text-sm">
          Tipo de Expressão: <span className="text-red-500">*</span>
        </label>
        <SelectTagInputWithCheckboxes
          value={value}
          onChange={(v) => {
            const newType = v.length > 0 ? v[v.length - 1] : undefined
            setValue('type', newType as EditPostFormData['type'], { shouldDirty: true })
          }}
          placeholder="Pesquisar"
          items={typeItems}
          loading={false}
          buttonLabel="Adicionar"
        />
      </div>
      <hr className="border-gray-200" />
    </div>
  )
}
